export default __webpack_public_path__ + "assets/images/g-content-bg1-30a02ade.png";